import { useState } from "react";
import AuthLayout from "../../../Layout/AuthLayout";
import { Link, useNavigate } from "react-router-dom";
import { useResetPasswordMutation } from "hooks/Auth/useResetPasswordMutation";
import Button from "Components/Button";
import Input from "Components/Input";
import { useConfirmResetPasswordMutation } from "hooks/Auth/useConfirmResetPasswordMutation";
import ResendOtp from "./ResendOtp";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [payload, setPayload] = useState({
    email: email,
    token: "",
    password: "",
  });
  const [level, setLevel] = useState(0);

  const { mutate, isPending } = useResetPasswordMutation();
  const { mutate: reset, isPending: isPendingReset } =
    useConfirmResetPasswordMutation();

  const navigate = useNavigate();

  const handleSubmit = () => {
    mutate(email, {
      onSuccess: () => {
        setLevel(1);
        setPayload({ ...payload, token: "" });
      },
    });
  };

  const handleReset = () => {
    reset(payload, {
      onSuccess: () => {
        navigate("/");
      },
    });
  };

  return (
    <AuthLayout
      title="Forgot Password"
      subTitle="Enter your email to recover your password"
      back={true}
    >
      {level === 0 && (
        <div>
          <Input
            name="email"
            type="email"
            value={email}
            placeholder="you@email.com"
            disabled={isPending}
            onChange={(e) => {
              setEmail(e?.target?.value);
              setPayload({ ...payload, email: e?.target?.value });
            }}
          />

          <Button
            onClick={handleSubmit}
            disabled={!email}
            isLoading={isPending}
            label={"Reset Password"}
          />
          <div className="mt-3 text-center">
            <span className="text-black font-medium">
              Remember Password?{" "}
              <Link to="/" className="text-orange">
                Login
              </Link>
            </span>
          </div>
        </div>
      )}
      {level === 1 && (
        <div>
          <Input
            name="email"
            type="email"
            value={payload?.email}
            placeholder="Email"
            disabled
            onChange={(e) =>
              setPayload({ ...payload, email: e?.target?.value })
            }
          />
          <Input
            name="token"
            type="text"
            value={payload?.token}
            obscured
            placeholder="Enter OTP"
            onChange={(e) =>
              setPayload({ ...payload, token: e?.target?.value })
            }
          />
          <Input
            name="password"
            type="password"
            value={payload?.password}
            placeholder="New Password"
            onChange={(e) =>
              setPayload({ ...payload, password: e?.target?.value })
            }
          />
          <Input
            name="confirmPassword"
            type="password"
            value={confirmPassword}
            placeholder="Confirm Password"
            onChange={(e) => setConfirmPassword(e?.target?.value)}
          />

          <Button
            onClick={handleReset}
            disabled={
              !payload?.email ||
              !payload?.password ||
              !payload?.token ||
              !confirmPassword ||
              payload?.password !== confirmPassword
            }
            isLoading={isPendingReset}
            label={"Submit"}
          />
          <div className="mt-3 text-center">
            <span className="text-black font-medium">
              Remember Password?{" "}
              <Link to="/" className="text-orange">
                Login
              </Link>
            </span>
          </div>
          <div>
            <ResendOtp onResend={handleSubmit} />
          </div>
        </div>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
